// extracted by mini-css-extract-plugin
export default {"outOfStock":"OutOfStock_outOfStock__Pm0F3"};